import React from "react";

export default function KeptiIcon({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none">
      <rect width="56" height="56" rx="14" fill="#1a2744"/>
      <rect x="13" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="30" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="13" y="30" width="13" height="13" rx="2" fill="#f0e6c8"/>
      <rect x="30" y="30" width="13" height="13" rx="2" fill="#c0392b"/>
    </svg>
  );
}
